import Vue from "vue";
import Vuex from "vuex";

import investment from "./investment.module";
import investorArticle from "./investorArticle.module";
import shares from "./shares.module";
import supportMessages from "./supportMessages.module";
import supportTicket from "./supportTickets.module";
import user from "./user.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    investment,
    investorArticle,
    shares,
    supportMessages,
    supportTicket,
    user
  }
});
